import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './ForgotPasswordLink.module.scss';
import cn from 'classnames';

interface Props {
  right?: boolean
}

function ForgotPasswordLink({ right }: Props) {
  const { t } = useTranslation();
  const linkClassName = cn(right && styles.right);

  return (
    <div className={styles.container}>
      <Link className={linkClassName} to={'/auth/recovery'}>
        <span className={styles.link}>{t('login.action.forgot_password')}</span>
      </Link>
    </div>
  )
}

export default ForgotPasswordLink;
